import React from 'react';
import './layout.scss';

//Presentational component that displays a sidebar if the page has one.
// TODO: will need to pass in sidebar content in props.
// If no sidebar content, it just holds the space open.
//Bootstrap notes:
//SidebarSection has 2 columns for med+ screen widths (col-md-2). Hide it for smaller screen widths (d-none d-md-block).

function SidebarSection(props) {
  if (props.contentComponent || props.page.sidebar){
    return(
      <div className="aa-sidebar-section col-md-2 d-none d-md-block" role="complementary">
        {props.contentComponent}
      </div>  
    );
  }
  else
    return(
      <div className="aa-sidebar-section col-md-2 d-none d-md-block"></div>
    );
}

export default SidebarSection;
